import "../instruments";
import { createRoot } from "react-dom/client";
import "react-json-view-lite/dist/index.css";
import "flexlayout-react/style/light.css";
import "./index.css";
import App from "./App.tsx";
import { Buffer } from "buffer";
import { HelmetProvider } from "react-helmet-async";

import "./i18n";

window.Buffer = Buffer;

createRoot(document.getElementById("root")!).render(
    <HelmetProvider>
        <App />
    </HelmetProvider>);
